import React from "react";
import Category from "../components/Category";
import { useData } from "../DataProvider";

function Items() {
  const data = useData();
  const { categories, items } = data;

  React.useEffect(() => {
    // const el = document.querySelector("div.live-event-buttons");
    // el?.remove();
  }, []);

  return (
    <div style={{ margin: 'auto' }}>
      {categories?.categories_ids?.map((id) => (
        <Category key={id} category={categories?.data[id]} allItems={items} />
      ))}
    </div>
  );
}

export default Items;